import React from "react";
import { TabState, UpdateFileOptions } from "@/apps/forge/states/tabs/TabState";
import { EditorFile } from "@/apps/forge/EditorFile";
import * as KotOR from "@/apps/forge/KotOR";
import { snapshotGff } from "@/apps/forge/helpers/gffUndoSnapshot";
import { beginUtxFileUpdate, finishUtxUndoApply } from "@/apps/forge/helpers/UTxEditorHelpers";
import * as THREE from 'three';
import BaseTabStateOptions from "@/apps/forge/interfaces/BaseTabStateOptions";
import { TabUTWEditor } from "@/apps/forge/components/tabs/tab-utw-editor/TabUTWEditor";
import { ForgeWaypoint } from "@/apps/forge/module-editor/ForgeWaypoint";

export class TabUTWEditorState extends TabState {
  tabName: string = `UTW`;
  waypoint: ForgeWaypoint = new ForgeWaypoint();
  
  get blueprint(): KotOR.GFFObject {
    return this.waypoint.blueprint;
  }

  constructor(options: BaseTabStateOptions = {}){
    super(options);

    this.setContentView(<TabUTWEditor tab={this}></TabUTWEditor>);
    this.openFile();
    this.saveTypes = [
      {
        description: 'Odyssey Waypoint Blueprint',
        accept: {
          'application/octet-stream': ['.utw']
        }
      }
    ];

    this.addEventListener('onTabRemoved', (tab: TabState) => {
      
    });
  }

  public openFile(file?: EditorFile){
    return new Promise<KotOR.GFFObject>( (resolve, reject) => {
      if(!file && this.file instanceof EditorFile){
        file = this.file;
      }
  
      if(file instanceof EditorFile){
        if(this.file != file) this.file = file;
        this.file.isBlueprint = true;
        this.tabName = this.file.getFilename();
  
        file.readFile().then( (response) => {
          this.waypoint = new ForgeWaypoint(response.buffer, file.resref);
          this.clearUndoHistory();
          this.processEventListener('onEditorFileLoad', [this]);
          resolve(this.blueprint);
        });
      }
    });
  }

  show(): void {
    super.show();
  }

  hide(): void {
    super.hide();
  }

  animate(delta: number = 0){
    //todo
  }

  async getExportBuffer(resref?: string, ext?: string): Promise<Uint8Array> {
    if(!!resref && ext == 'utw'){
      this.waypoint.templateResRef = resref;
      this.updateFile({ skipHistory: true });
      return this.waypoint.blueprint.getExportBuffer();
    }
    return super.getExportBuffer(resref, ext);
  }

  updateFile(options?: UpdateFileOptions){
    beginUtxFileUpdate(this, options);
    this.waypoint.exportToBlueprint();
  }

  protected captureUndoState(): Uint8Array | undefined {
    return snapshotGff(this.blueprint);
  }

  protected applyUndoState(state: Uint8Array): void {
    this.waypoint = new ForgeWaypoint(state, this.file?.resref);
    finishUtxUndoApply(this);
  }

}
